import { IconButton, Stack, Tooltip } from "@mui/material";
import { FaBuildingColumns, FaMagnifyingGlass, FaPen, FaTrash, FaWhatsapp } from "react-icons/fa6";
import { Link } from "react-router-dom";
import ListingPage from '../../components/DynamicListingPage';
import { deleteCustomer, getCustomers } from '../../helpers/http_customers_requests';
import { CurrentSwitch } from '../../components/CurrentSwitch';
import { useMutation, useQuery } from '@tanstack/react-query';
import { usePermissions } from "../../providers/PermissionsProvider";
import { useAuth } from "../../providers/AuthProvider";
import { confirmAndExecuteFn } from '../../utils/functions';
import { useState } from "react";

export default function Customers() {

    const { verifyPermission } = usePermissions();

    const [filterValues, setFilterValues] = useState({});

    const handleFilterChange = (field, value) => {
        setFilterValues(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const { data, isFetching, refetch } = useQuery({
        queryKey: ['getCustomers', filterValues],
        queryFn: () => getCustomers(filterValues),
        staleTime: 1000 * 5
    });

    const { id: user_id } = useAuth();

    const { customers = [] } = data?.data ?? {};

    const columns = [
        { field: 'image', headerName: 'Foto', },
        {
            field: 'complete_name',
            headerName: 'Nome',
        },
        {
            field: 'whatsapp_number',
            headerName: 'Contato',
        },
        {
            field: 'cnpj',
            headerName: 'CNPJ',
            type: 'number',
        },
        {
            field: 'actions',
            headerName: 'Ações',
            type: 'number',
        },
    ];

    const deleteMutation = useMutation({
        mutationFn: (id) => deleteCustomer(id, user_id),
        onSuccess: () => {
            setTimeout(() => {
                refetch();
            }, 1000);
        }
    });

    const handleDelete = (id) => {
        confirmAndExecuteFn('Tem certeza que deseja deletar este cliente?', () => {
            deleteMutation.mutate(id);
        });
    };

    const componentName = 'customers';

    const filters = [
        {
            field: 'is_active',
            type: 'select',
            label: 'Status',
            options: [
                { value: '1', label: 'Ativo' },
                { value: '0', label: 'Inativo' }
            ]
        },
    ];

    const renderActions = (row) => (
        <Stack spacing={1} direction={'row'} justifyContent={'center'}>
            {verifyPermission(componentName, 1) && (
                <Tooltip title="Status" arrow placement="top">
                    <span><IconButton disabled><CurrentSwitch title="status" status={row.is_active} /></IconButton></span>
                </Tooltip>
            )}
            {verifyPermission(componentName, 1) && (
                <Tooltip title="Iniciar conversa no WhatsApp" arrow placement="top">
                    <IconButton target="_blank" href={`http://wa.me/55${row?.whatsapp_number?.replace(/\D/g, "")}`}>
                        <FaWhatsapp color="green" />
                    </IconButton>
                </Tooltip>
            )}
            {verifyPermission(componentName, 1) && (
                <Tooltip title="Ver detalhes" arrow placement="top">
                    <IconButton color="primary" LinkComponent={Link} to={`/cliente-detalhes/${row.id}`}>
                        <FaMagnifyingGlass size={20} />
                    </IconButton>
                </Tooltip>
            )}
            {verifyPermission(componentName, 2) && (
                <Tooltip title="Editar" arrow placement="top">
                    <IconButton color="primary" LinkComponent={Link} to={`/cliente-editar/${row.id}`}>
                        <FaPen size={20} />
                    </IconButton>
                </Tooltip>
            )}
            {verifyPermission(componentName, 4) && (
                <Tooltip title="Deletar" arrow placement="top">
                    <IconButton color="error" onClick={() => handleDelete(row.id)}>
                        <FaTrash size={20} />
                    </IconButton>
                </Tooltip>
            )}
        </Stack>
    );

    return <ListingPage
        canAddData={verifyPermission(componentName, 3)}
        isLoading={isFetching}
        icon={FaBuildingColumns}
        createWithLink
        pageTitle={"Clientes Inovart Gold"}
        addPath={"/cliente-cadastrar"}
        columns={columns}
        data={customers}
        actions={renderActions}
        filters={filters}
        filterValues={filterValues}
        onFilterChange={handleFilterChange}
    />
};